export default "__VITE_ASSET__B7cl6ZHV__"